module.exports = __webpack_public_path__ + "static/media/gas2.72301d02.jpg";